/**
 * Entity deep-link helpers. Only mark an entity as routable when a real
 * by-id load path exists (or is explicitly deferred / blocked).
 */

export const ENTITY_DEEP_LINK_STATUS = {
  tenant: {
    entity: 'tenant',
    list: true,
    byId: true,
    endpoint: 'GET /api/v1/super-admin/tenants/{id}/',
    pathTemplate: '/lojas/:tenantId',
    status: 'implementado',
  },
  cockpit: {
    entity: 'cockpit',
    list: false,
    byId: true,
    endpoint: 'via tenant getById',
    pathTemplate: '/lojas/:tenantId/cockpit/:tab?',
    status: 'implementado',
  },
  plan: {
    entity: 'plan',
    list: true,
    byId: false,
    endpoint: null,
    pathTemplate: '/planos/permissoes/:planId',
    status: 'nao_implementado_por_falta_de_endpoint',
    note: 'planService.listPlans + getPlanRoutes(code); sem getPlan(id)',
  },
  ticket: {
    entity: 'ticket',
    list: true,
    byId: false,
    endpoint: null,
    pathTemplate: '/suporte/tickets/:ticketId',
    status: 'bloqueado_por_guard',
    note: 'SA_MVP_HIDDEN_ROUTES; sem getTicket(id) — usar ?ticketId= opcional atrás do guard',
  },
  article: {
    entity: 'article',
    list: true,
    byId: false,
    endpoint: null,
    pathTemplate: '/suporte/base-conhecimento/artigos/:articleId/editar',
    status: 'bloqueado_por_guard',
    note: 'Sem getArticle(id); editor novo pode usar ?ticketId=',
  },
  auditEvent: {
    entity: 'audit_event',
    list: true,
    byId: true,
    endpoint: 'GET audit-logs/{id}/ via auditService.getLog',
    pathTemplate: '/auditoria/:eventId',
    status: 'implementado',
  },
  incident: {
    entity: 'incident',
    list: true,
    byId: false,
    endpoint: null,
    pathTemplate: '/observabilidade/incidentes/:incidentId',
    status: 'nao_implementado_por_falta_de_endpoint',
  },
  notification: {
    entity: 'notification',
    list: true,
    byId: false,
    endpoint: null,
    pathTemplate: '/notificacoes/:notificationId',
    status: 'nao_implementado_por_falta_de_endpoint',
  },
};

export function getEntityDeepLinkStatus(entity) {
  return ENTITY_DEEP_LINK_STATUS[entity] || null;
}

export function buildAuditoriaEventPath(eventId) {
  if (eventId == null || String(eventId).trim() === '') return '/auditoria';
  return `/auditoria/${encodeURIComponent(String(eventId).trim())}`;
}

export function buildKbNewArticlePath(ticketId) {
  const base = '/suporte/base-conhecimento/artigos/novo';
  if (ticketId == null || String(ticketId).trim() === '') return base;
  return `${base}?ticketId=${encodeURIComponent(String(ticketId).trim())}`;
}

export function buildTicketPath(ticketId) {
  if (ticketId == null || String(ticketId).trim() === '') return '/suporte/tickets';
  return `/suporte/tickets/${encodeURIComponent(String(ticketId).trim())}`;
}

export function isEntityDeepLinkDelivered(entity) {
  const row = ENTITY_DEEP_LINK_STATUS[entity];
  return row?.status === 'implementado';
}
